import { request } from './axios';

// 小程序详情
export function getaccountbasicinfo(data) {
  return request({
    url: `/api/access/pb/cmd/ApiServer/WeixinMiniProgramService/WeixinCommonRequest`,
    data,
  });
}

// 获取服务器域名
export function domain(data) {
  return request({
    url: `/api/access/pb/cmd/ApiServer/WeixinMiniProgramService/WeixinCommonRequest`,
    data,
  });
}

// 获取业务域名
export function setwebviewdomain(data) {
  return request({
    url: `/api/access/pb/cmd/ApiServer/WeixinMiniProgramService/WeixinCommonRequest`,
    data,
  });
}

// 获取小程序二维码
export function qrcodejumpget(data) {
  return request({
    url: `/api/access/pb/cmd/ApiServer/WeixinMiniProgramService/WeixinCommonRequest`,
    data,
  });
}

// 获取小程序二维码
export function getwxacode(data) {
  return request({
    url: `/api/access/pb/cmd/ApiServer/WeixinMiniProgramService/WeixinCommonRequestBytes`,
    data,
  });
}

// 小程序二维码发布
export function qrcodejumppublish(data) {
  return request({
    url: `/wx/${data._appid}/proxy/cgi-bin/wxopen/qrcodejumppublish`,
    data,
  });
}
// 下载检验文件
export function qrcodejumpdownload(data) {
  return request({
    url: `/api/access/pb/cmd/ApiServer/WeixinMiniProgramService/WeixinCommonRequest`,
    data,
  });
}
// 增加或修改二维码规则
export function qrcodejumpadd(data) {
  return request({
    url: `/api/access/pb/cmd/ApiServer/WeixinMiniProgramService/WeixinCommonRequest`,
    data,
  });
}
// 删除二维码规则
export function qrcodejumpdelete(data) {
  return request({
    url: `/api/access/pb/cmd/ApiServer/WeixinMiniProgramService/WeixinCommonRequest`,
    data,
  });
}
// 获取体验管理人员列表
export function memberauth(data) {
  return request({
    url: `/api/access/pb/cmd/WeixinServer/WeixinMiniProgramService/MemberAuthList`,
    data,
  });
}
// 绑定体验者
export function bindtester(data) {
  return request({
    url: `/api/access/pb/cmd/WeixinServer/WeixinMiniProgramService/BindTester`,
    data,
  });
}
// 解除绑定人员
export function unbindtester(data) {
  return request({
    url: `/api/access/pb/cmd/WeixinServer/WeixinMiniProgramService/UnbindTester`,
    data,
  });
}
// 获取小程序列表
export function getAppList(data) {
  return request({
    url: `/api/access/pb/cmd/WeixinServer/WeixinMiniProgramService/GetWeixinMiniProgramList`,
    data,
  });
}
// 获取提审记录
export function getAuditList(data) {
  return request({
    url: `/api/access/pb/cmd/WeixinServer/WeixinMiniProgramService/GetAuditList`,
    data,
  });
}

// 获取版本信息
export function getVersion(data) {
  return request({
    url: `/api/access/pb/cmd/WeixinServer/WeixinMiniProgramService/GetVersionInfo`,
    data,
  });
}
// 上传体验版本
export function uploadCommits(data) {
  return request({
    url: `/api/access/pb/cmd/WeixinServer/WeixinMiniProgramService/Commit`,
    data,
  });
}

// 设置体验版本二维码 没用
export function getQrcode(data) {
  return request({
    url: `/wx/${data._appid}/proxy/wxa/get_qrcode`,
    type: 'get',
    data,
  });
}

// 提交审核
export function submitAudit(data) {
  return request({
    url: `/api/access/pb/cmd/WeixinServer/WeixinMiniProgramService/SubmitAudit`,
    data,
  });
}
// 发布审核版本
export function releaseAudit(data) {
  return request({
    url: `/api/access/pb/cmd/WeixinServer/WeixinMiniProgramService/ReleaseMiniProgram`,
    data,
  });
}
// 版本回退
export function revertcoderelease(data) {
  return request({
    url: `/api/access/pb/cmd/WeixinServer/WeixinMiniProgramService/RevertVersion`,
    data,
  });
}
// 暂停服务
export function changeVisitstatus(data) {
  return request({
    url: `/api/access/pb/cmd/ApiServer/WeixinMiniProgramService/WeixinCommonRequest`,
    data,
  });
}
// 加急审核
export function speedUpaudit(data) {
  return request({
    url: `/api/access/pb/cmd/ApiServer/WeixinMiniProgramService/WeixinCommonRequest`,
    data,
  });
}
// 撤销审核
export function unDocodeaudit(data) {
  return request({
    url: `/api/access/pb/cmd/WeixinServer/WeixinMiniProgramService/RevokeApprovalCommit`,
    data,
  });
}
// 查询隐私保护指引
export function getprivacysetting(data) {
  return request({
    url: `/api/access/pb/cmd/ApiServer/WeixinMiniProgramService/WeixinCommonRequest`,
    data,
  });
}
// 	设置隐私保护指引
export function setprivacysetting(data) {
  return request({
    url: `/api/access/pb/cmd/ApiServer/WeixinMiniProgramService/WeixinCommonRequest`,
    data,
  });
}
// 	上传隐私保护指引
export function uploadprivacyextfile(data) {
  return request({
    url: `/api/access/pb/cmd/ApiServer/WeixinMiniProgramService/WeixinCommonUploadPrivacyExtFile`,
    data,
  });
}
// 	获取发布记录
export function commiRecord(data) {
  return request({
    url: `/api/access/pb/cmd/WeixinServer/WeixinMiniProgramService/GetCommitRecord`,
    data,
  });
}
// 	获取小程序路径地址
export function getPathOptions(data) {
  return request({
    url: `/api/access/pb/cmd/ApiServer/WeixinMiniProgramService/WeixinCommonRequest`,
    data,
  });
}
// 获取uid
export function getuid(data) {
  return request({
    url: `/api/access/pb/cmd/WeixinServer/WeixinMiniProgramService/GetUid`,
    data,
  });
}
// 获取uid 没用
export function setuid(data) {
  return request({
    url: `/uid/${data.appid}/setuid`,
    data,
  });
}

// 	上传媒体文件
export function uploadmedia(data) {
  return request({
    url: `/api/access/pb/cmd/ApiServer/WeixinMiniProgramService/WeixinCommonUploadFile`,
    data,
  });
}

// 撤销审核
export function undocodeaudit(appid, data) {
  return request({
    url: `/api/access/pb/cmd/WeixinServer/WeixinMiniProgramService/RevokeApprovalCommit`,
    data,
  });
}

// 获取最新一次的审核详情
export function getLastAuditstatus(data) {
  return request({
    url: `/api/access/pb/cmd/ApiServer/WeixinMiniProgramService/WeixinCommonRequest`,
    data,
  });
}
